import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';


const api = 'https://hazmatargentina.com/hazmat/public/api/v1';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable({
  providedIn: 'root'
})

export class CotizacionService {

  constructor(private http: HttpClient) { }

  sendForm(data) {
    return this.http.post<any>(`${api}/mails/cotizacion`, data, httpOptions);
  }


}
